<template>
  <section class="faq">
    <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
    <section class="faqapp">
      <div>
        <h2 class="faq_title">ToTok Basics</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_basics"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">
          Group Chats, Group Calls, and Group Management
        </h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_group"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">PayBy on ToTok</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_totokpay"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">ToTok Official Account</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_official_account"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">Security and Privacy</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_privacy"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">Your Account</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_count"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">Troubleshooting</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_trouble"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
      <div>
        <h2 class="faq_title">ToTok Support</h2>
        <h4
          class="faq_item"
          v-for="(item, index) in faq_info_support"
          :key="index"
          @click="show_faq(item.routeName)"
        >
          {{ item.label }}
        </h4>
      </div>
    </section>
    <Footer></Footer>
    <FootBanner v-show="!isPc && !isIOS"></FootBanner>
  </section>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
import NavCrumbs from "@/components/NavCrumbs.vue";
export default {
  created() {
  },
  metaInfo() {
    return {
      title: "FAQ – How to use ToTok to video call and chat",
      meta: [
        {
          Description:
            "Learn how to download ToTok app, how to use ToTok, how to add contacts, and how to make free video calls and conference calls.",
        },
        { property: "og:title", content: "FAQ – How to use ToTok to video call and chat" },
        { property: "og:url", content: "https://totok.ai/faq" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "Learn how to download ToTok app, how to use ToTok, how to add contacts, and how to make free video calls and conference calls.",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    Footer,
    FootBanner,
    NavCrumbs,
  },
  data() {
    return {
      crumbProp: {
        label: "FAQ",
        type: "simple",
      },
      faq_info_basics: [
        {
          routeName: "how-to-download-totok",
          label: "How to download ToTok?",
        },
        {
          routeName: "how-to-update-totok",
          label: "How to update ToTok?",
        },
        {
          routeName: "How-to-reinstall-ToTok",
          label: "How to reinstall ToTok?",
        },
        {
          routeName: "what-are-the-supported-devices-of-totok",
          label: "What are the supported devices of ToTok?",
        },
        {
          routeName: "which-country-region-is-totok-available-in",
          label: "Which country/region is ToTok available in?",
        },
        {
          routeName: "how-to-create-a-totok-account",
          label: "How to create a ToTok account?",
        },
        {
          routeName:
            "can-i-use-one-totok-account-on-multiple-phones-or-with-multiple-phone-numbers",
          label:
            "Can I use one ToTok account on multiple phones, or with multiple phone numbers?",
        },
        {
          routeName:
            "can-i-create-more-than-one-account-using-one-phone-number",
          label: "Can I create more than one account using one phone number?",
        },
        {
          routeName: "how-to-manage-my-profile",
          label: "How to manage my profile?",
        },
        {
          routeName: "do-i-need-a-totok-id",
          label: "Do I need a ToTok ID?",
        },
        {
          routeName:
            "if-someone-finds-me-by-totok-id-messages-me-and-i-reply-will-they-know-my-number",
          label:
            "If someone finds me by ToTok ID, messages me and I reply — will they know my number?",
        },
        {
          routeName: "how-do-i-delete-my-totok-id",
          label: "How do I delete my ToTok ID?",
        },
        {
          routeName: "what-do-i-do-if-my-totok-id-is-taken",
          label: "What do I do if my ToTok ID is taken?",
        },
        {
          routeName: "what-if-someone-is-pretending-to-be-me",
          label: "What if someone is pretending to be me?",
        },
        {
          routeName: "how-to-generate-your-account-qr-code-or-a-group-qr-code",
          label: "How to generate my account QR code or a group QR code?",
        },
        {
          routeName: "who-can-i-connect-with-on-totok",
          label: "Who can I connect with on ToTok?",
        },
        {
          routeName: "how-do-i-know-who-in-my-contacts-has-totok",
          label: "How do I know who in my contacts has ToTok?",
        },
        {
          routeName: "how-do-i-invite-my-friends",
          label: "How do I invite my friends?",
        },
        {
          routeName: "is-it-free-to-send-messages-or-make-calls-over-totok",
          label: "Is it free to send messages or make calls over ToTok?",
        },
        {
          routeName: "how-to-use-voice-messages",
          label: "How to use voice messages?",
        },
        {
          routeName: "how-to-make-voice-calls",
          label: "How to make voice calls?",
        },
        {
          routeName: "how-to-make-video-calls",
          label: "How to make video calls?",
        },
        {
          routeName: "how-to-switching-between-voice-and-video-calls",
          label: "How to switch between voice and video calls?",
        },
        {
          routeName: "how-to-copy-or-reply-to-a-message",
          label: "How to copy or reply to a message?",
        },
        {
          routeName:
            "how-to-send-photos-videos-documents-location-and-contacts-over-totok",
          label:
            "How to send photos, videos, documents, location and contacts over ToTok?",
        },
        {
          routeName:
            "how-to-forward-photos-videos-documents-location-and-contacts",
          label:
            "How to forward photos, videos, documents, location and contacts?",
        },
        {
          routeName: "how-to-delete-sent-messages",
          label: "How to delete sent messages?",
        },
        {
          routeName: "how-to-delete-chats-with-your-contacts",
          label: "How to delete chats with my contacts?",
        },
        {
          routeName: "what-is-the-last-seen-online-and-the-other-side-time",
          label:
            "What is the ‘last seen’, ‘online’, and the other side’s time?",
        },
        {
          routeName: "can-i-hide-my-last-seen-or-local-time",
          label: "Can I hide my ‘last seen’ or local time?",
        },
        {
          routeName: "how-to-pin-chat",
          label: "How to pin a chat?",
        },
        {
          routeName: "how-can-i-use-gifs",
          label: "How can I use GIFs?",
        },
        {
          routeName: "how-do-i-delete-contacts",
          label: "How do I delete contacts?",
        },
        {
          routeName: "Restore-chats-from-local-backup",
          label: "Restore chats from local backup",
        },
      ],

      faq_info_official_account: [
        {
          routeName: "what-is-official-account",
          label: "What is Official Account?",
        },
        {
          routeName: "how-to-activate-the-official-account-feature",
          label: "How to activate the Official Account feature?",
        },
        {
          routeName: "how-to-follow-an-official-account",
          label: "How to follow an official account?",
        },
        {
          routeName: "how-to-get-information-and-interact-with-the-official-account",
          label: "How to get information and interact with the official account?",
        },
        {
          routeName: "how-to-unfollow-an-official-account",
          label: "How to unfollow an official account?",
        },
        {
          routeName: "how-to-manage-my-official-account-list",
          label: "How to manage my official account list?",
        },
      ],
      faq_info_totokpay: [
        {
          routeName: "how-to-use-payby-on-totok",
          label: "How to use PayBy on ToTok",
        },
      ],
      faq_info_group: [
        {
          routeName: "what-is-the-maximum-people-in-one-group-chat",
          label: "What is the maximum number of people in one group call?",
        },
        {
          routeName: "what-is-the-maximum-people-in-one-group-call",
          label: "What is the maximum number of people in one group call?",
        },
        {
          routeName: "how-to-create-a-group",
          label: "How to create a group?",
        },
        {
          routeName: "how-to-invite-people-to-join-a-group",
          label: "How to invite people to join a group?",
        },
        {
          routeName: "how-to-add-new-members-to-groups",
          label: "How to add new members to groups?",
        },
        {
          routeName: "how-to-make-a-group-voice-or-video-call",
          label: "How to make a group voice or video call?",
        },
        {
          routeName: "how-to-remove-a-group-member",
          label: "How to remove a group member?",
        },
        {
          routeName: "how-to-manage-group-admins",
          label: "How to manage group admins?",
        },
        {
          routeName: "how-to-make-a-member-an-admin",
          label: "How to make a member an admin?",
        },
        {
          routeName: "how-to-dismiss-an-admin",
          label: "How to dismiss an admin?",
        },
        {
          routeName: "who-can-make-changes-to-groups",
          label: "Who can make changes to groups?",
        },
        {
          routeName: "how-to-change-the-group-access-settings",
          label: "How to change the group access settings?",
        },
        {
          routeName: "how-to-change-the-group-name-and-group-photo",
          label: "How to change the group name and group photo?",
        },
        {
          routeName: "how-to-mute-group-notifications",
          label: "How to mute group notifications?",
        },
        {
          routeName: "how-to-mention-someone-in-a-group",
          label: "How to mention someone in a group?",
        },
        {
          routeName: "how-to-set-admin-message",
          label: "How to set admin message?",
        },
        {
          routeName: "how-to-leave-a-group",
          label: "How to leave a group?",
        },
      ],
      faq_info_privacy: [
        {
          routeName: "how-secure-is-totok",
          label: "How secure is ToTok?",
        },
        {
          routeName: "account-security-tips",
          label: "Account Security Tips",
        },
        {
          routeName: "how-can-i-check-read-receipts",
          label: "How can I check Read Receipts?",
        },
        {
          routeName: "missing-read-receipts",
          label: "Missing Read Receipts",
        },
        {
          routeName: "how-can-i-know-i-am-blocked-by-someone",
          label: "How can I know I am blocked by someone?",
        },
        {
          routeName: "how-can-i-block-and-unblock-contacts",
          label: "How can I block and unblock contacts?",
        },
        {
          routeName: "why-you-asked-for-my-phone-number-and-address-book",
          label: "Why you asked for my phone number and address book?",
        },
        {
          routeName: "how-can-i-add-a-password",
          label: "How can I add a password?",
        },
        {
          routeName: "what-if-i-forget-my-account-password",
          label: "What if I forget my account password?",
        },
      ],
      faq_info_count: [
        {
          routeName: "who-can-see-my-phone-number",
          label: "Who can see my phone number?",
        },
        {
          routeName: "how-do-i-log-out",
          label: "How do I log out?",
        },
        {
          routeName: "how-do-i-change-my-phone-number",
          label: "How do I change my phone number?",
        },
        {
          routeName: "how-do-i-delete-my-account",
          label: "How do I delete my account?",
        },
        {
          routeName: "what-happens-if-i-delete-my-account",
          label: "What happens if I delete my account?",
        },
        {
          routeName: "my-account-was-lost-or-stolen-what-do-i-do",
          label: "My account was lost or stolen, what do I do?",
        },
        {
          routeName: "my-phone-was-lost-or-stolen-what-do-i-do",
          label: "My phone was lost or stolen, what do I do?",
        },
      ],
      faq_info_trouble: [
        {
          routeName: "problems-sending-and-receiving-messages",
          label: "Problems with sending and receiving messages",
        },
        {
          routeName: "problems-with-contacts",
          label: "Problems with Contacts",
        },
        {
          routeName: "incorrect-timestamps-on-messages",
          label: "Incorrect timestamps on messages",
        },
        {
          routeName: "notifications-are-not-working",
          label: "Notifications are not working",
        },
        {
          routeName: "troubles-with-audio-or-video-quality",
          label: "Troubles with audio or video quality",
        },
      ],
      faq_info_support: [
        {
          routeName: "customer-service",
          label: "Customer service",
        },
        {
          routeName: "social-media",
          label: "Social media",
        },
      ],
    };
  },
  computed: {
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    show_faq(routeName) {
      console.log("routeName", routeName);
      this.$router.push(`faq/${routeName.toLowerCase()}`);
    },
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .faq {
        // padding-top: 1.5rem;
        .faqapp{
            margin-bottom: 30px;
                padding: 18px;
        }
        // padding-left: 20px;
        // padding-right: 20px;
    }
}

@media only screen and (min-width: 701px) {
    .faq {
            padding-top: 88px;
        .faqapp{
            width: 800px;
            margin: 0 auto;
            margin-bottom: 30px;
        }

    }
    .faq_title_container{
        color: #4378f2;
        font-size: 24px;
        font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
    }
}
</style>
<style lang="stylus">
.el-collapse-item__header {
    font-weight 600
    color: #4378f2
    cursor pointer
}

.el-collapse-item__content div:hover {
    text-decoration: underline;
    cursor pointer
}
</style>
